<template>
  <div class="no-data">
      <img :src="imgSrc"/>
      <span>{{title}}</span>
  </div>
</template>

<script>
export default{
  	props:{
      title:{
        type:String,
        default:'暂无数据'
      },
      imgSrc:{
        type:String,
        default:'../../../static/img/no_context.png'
      }
    },
  }
</script>

<style lang="less" scoped>
  .no-data{text-align: center;margin: 80% 0;}
  .no-data img{width: 76px;height: 76px;}
  .no-data span{color: @attendance-color-2;font-size:15px;margin-top: 15px; display: block;font-weight: 300;}
</style>



// WEBPACK FOOTER //
// src/components/common/noContext.vue